import { FC, useContext, useState } from "react";
import { Controller } from "react-hook-form";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../../../context/notificationContext";
import useI18n from "../../../../hooks/useTranslations";
import { Handle } from "../../../../http/vertigrip/types/handles";
import { useHandlesApi } from "../../../../http/vertigrip/useHandles";
import Button from "../../../ui/Button";
import Form from "../../../ui/Form";
import FormField from "../../../ui/FormField";
import FormFieldsContainer from "../../../ui/FormFieldsContainer";
import ModalDialog from "../../../ui/ModalDialog";
import VisibilityScope, { VisibilityScopeValue } from "../../../ui/VisibilityScope";

interface UpdateHandleForm {
  visibility: VisibilityScopeValue;
}

interface EditHandleModalDialogProps {
  handle?: Handle;
  onClose: () => void;
}

const EditHandleModalDialog: FC<EditHandleModalDialogProps> = ({ handle, onClose }: EditHandleModalDialogProps) => {
  const i18n = useI18n();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const handlesApi = useHandlesApi();

  return (
    <>
      {!!handle && (
        <ModalDialog onClose={() => onClose()} title={i18n.translation.handles.edit}>
          <Form<UpdateHandleForm>
            defaultValues={{
              visibility: handle?.visibility,
            }}
            submitText={i18n.translation.common.save}
            disabled={isSubmitting}
            secondaryButton={
              <Button buttonProps={{ onClick: () => onClose() }} type="secondary">
                {i18n.translation.common.cancel}
              </Button>
            }
            onSubmit={() => (formData) =>
              handlesApi
                .updateAdminHandle(handle?.id!, {
                  visibility: formData.visibility,
                })
                .then(() => {
                  onClose();
                  dispatch(showSuccessNotification(i18n.translation));
                })
                .catch((err) => {
                  dispatch(showErrorNotification(i18n, err));
                  setIsSubmitting(false);
                })
            }
          >
            {({ setValue, control }) => {
              return (
                <FormFieldsContainer fullWidth>
                  <Controller
                    name="visibility"
                    control={control}
                    rules={{ required: true }}
                    render={({ field, fieldState }) => (
                      <FormField label={i18n.translation.common.visibility} error={fieldState.error} isOptional>
                        {({ labelId }) => (
                          <VisibilityScope
                            {...field}
                            inputId={labelId}
                            onChange={(value) => setValue("visibility", value)}
                          />
                        )}
                      </FormField>
                    )}
                  />
                </FormFieldsContainer>
              );
            }}
          </Form>
        </ModalDialog>
      )}
    </>
  );
};

export default EditHandleModalDialog;
